<template>
  <div class="text-center mt-5 card">
    <h2 class="text-lg font-semibold text-center text-slate-900">No projects</h2>
    <p>Get started by initiating a new project today!</p>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '@unhead/vue'

useHead({
  title: 'Projects'
})
</script>
